(function(){'use strict';function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var CART_DRAWER_SELECTOR="#cart-drawer",PARENT_LINE_SELECTOR="[data-gift-wrap-parent]",CONTROL_SELECTOR="[data-gift-wrap-control]",WRAP_FLAG_PROPERTY="_gift_wrap",WRAP_MAP_PROPERTY="_gift_wrap_item_ids",SELF_DISPATCHED_EVENTS=["gift-wrap:change","gift-wrap:reconcile"];function isWrapLine(e,t){return Boolean(t)&&(null==e?void 0:e.product_id)===t}function isWrappedLine(e){var t,r=null==e||null===(t=e.properties)||void 0===t?void 0:t[WRAP_FLAG_PROPERTY];return null!=r&&""!==r}function computeWrapState(e,t){var r,n={},a=0;return (null!==(r=null==e?void 0:e.items)&&void 0!==r?r:[]).forEach((function(e){if(!isWrapLine(e,t)&&isWrappedLine(e)){var r=String(e.variant_id),o=parseInt(n[r],10)||0;n[r]=String(o+e.quantity),a+=e.quantity;}})),{quantity:a,itemIds:n}}function withWrapFlag(e){var t=_objectSpread2({},e);return delete t[WRAP_FLAG_PROPERTY],_objectSpread2(_defineProperty({},WRAP_FLAG_PROPERTY,1),t)}function withClearedWrapFlag(e){var t=_objectSpread2({},e);return delete t[WRAP_FLAG_PROPERTY],_objectSpread2(_defineProperty({},WRAP_FLAG_PROPERTY,""),t)}function wrapMapsEqual(e,t){var r=Object.keys(null!=e?e:{}),n=Object.keys(null!=t?t:{});return r.length===n.length&&r.every((function(r){return String(e[r])===String(null==t?void 0:t[r])}))}function wrapLineMatchesState(e,t){var r;return e?e.quantity===t.quantity&&wrapMapsEqual(null===(r=e.properties)||void 0===r?void 0:r[WRAP_MAP_PROPERTY],t.itemIds):0===t.quantity}function getDrawer(){return document.querySelector(CART_DRAWER_SELECTOR)}function getWrapProductId(e){return parseInt(null==e?void 0:e.dataset.giftWrapProductId,10)||null}function getWrapVariantId(e){return parseInt(null==e?void 0:e.dataset.giftWrapVariantId,10)||null}function getParentLineItem(e){return null==e?void 0:e.closest(PARENT_LINE_SELECTOR)}function bundleSections(){var e=new Set;return document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections",{bubbles:!0,detail:{sections:e}})),_toConsumableArray(e).join(",")}function setLoading(e){document.documentElement.dispatchEvent(new CustomEvent(e?"theme:loading:start":"theme:loading:end",{bubbles:!0}));}function dispatchCartChange(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"gift-wrap:change";document.documentElement.dispatchEvent(new CustomEvent("cart:change",{bubbles:!0,detail:{baseEvent:t,cart:e}}));}function showLineError(e,t){var r=null==e?void 0:e.querySelector(".line-item__error-container");r&&(r.innerHTML="",t&&r.insertAdjacentHTML("afterbegin",'<p class="h-stack gap-1.5 text-sm text-error" role="alert">'.concat(t,"</p>")));}function postCartJson(e,t){return _postCartJson.apply(this,arguments)}function _postCartJson(){return (_postCartJson=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r){var n,a;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,fetch("".concat(Shopify.routes.root).concat(t),{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(r)});case 2:if((n=e.sent).ok){e.next=8;break}return e.next=6,n.json();case 6:throw a=e.sent,new Error(a.description||a.message||"");case 8:return e.abrupt("return",n.json());case 9:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function fetchCart(){return _fetchCart.apply(this,arguments)}function _fetchCart(){return (_fetchCart=_asyncToGenerator(_regeneratorRuntime().mark((function e(){var t;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,fetch("".concat(Shopify.routes.root,"cart.js"));case 2:if((t=e.sent).ok){e.next=9;break}return e.t0=Error,e.next=7,t.text();case 7:throw e.t1=e.sent,new e.t0(e.t1);case 9:return e.abrupt("return",t.json());case 10:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function fetchCartWithSections(e){return _fetchCartWithSections.apply(this,arguments)}function _fetchCartWithSections(){return (_fetchCartWithSections=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,fetchCart();case 2:return r=e.sent,t&&(r.sections=t),e.abrupt("return",r);case 5:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function setLineWrapFlag(e,t,r){return _setLineWrapFlag.apply(this,arguments)}function _setLineWrapFlag(){return (_setLineWrapFlag=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r,n){var a,o;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,fetchCart();case 2:if(a=e.sent,o=a.items.find((function(e){return e.key===t}))){e.next=6;break}throw new Error("");case 6:return e.abrupt("return",postCartJson("cart/change.js",{id:t,quantity:o.quantity,properties:r?withWrapFlag(o.properties):withClearedWrapFlag(o.properties),sections:n}));case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function syncWrapLine(e,t){return _syncWrapLine.apply(this,arguments)}function _syncWrapLine(){return (_syncWrapLine=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r){var n,a,o,i,c,s;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(a=getDrawer(),o=getWrapProductId(a),i=computeWrapState(t,o),!wrapLineMatchesState(c=null===(n=t.items)||void 0===n?void 0:n.find((function(e){return isWrapLine(e,o)})),i)){e.next=6;break}return e.abrupt("return",t);case 6:if(0!==i.quantity){e.next=8;break}return e.abrupt("return",postCartJson("cart/update.js",{updates:_defineProperty({},c.key,0),sections:r}));case 8:if(c){e.next=13;break}return e.next=11,postCartJson("cart/add.js",{items:[{id:getWrapVariantId(a),quantity:i.quantity,properties:_defineProperty({},WRAP_MAP_PROPERTY,i.itemIds)}],sections:r});case 11:return s=e.sent,e.abrupt("return",fetchCartWithSections(s.sections));case 13:return e.abrupt("return",postCartJson("cart/change.js",{id:c.key,quantity:i.quantity,properties:_defineProperty({},WRAP_MAP_PROPERTY,i.itemIds),sections:r}));case 14:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function toggleWrap(e,t){return _toggleWrap.apply(this,arguments)}function _toggleWrap(){return (_toggleWrap=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r){var n,a,o,i,c;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=getParentLineItem(t),a=t.dataset.parentLineKey){e.next=4;break}return e.abrupt("return");case 4:return o=bundleSections(),setLoading(!0),e.prev=6,e.next=9,setLineWrapFlag(a,r,o);case 9:return i=e.sent,e.next=12,syncWrapLine(i,o);case 12:c=e.sent,showLineError(n,""),dispatchCartChange(c),e.next=21;break;case 17:throw e.prev=17,e.t0=e.catch(6),showLineError(n,e.t0.message),e.t0;case 21:return e.prev=21,setLoading(!1),e.finish(21);case 24:case"end":return e.stop()}}),e,null,[[6,17,21,24]])})))).apply(this,arguments)}function reconcileWrapLine(e){return _reconcileWrapLine.apply(this,arguments)}function _reconcileWrapLine(){return (_reconcileWrapLine=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r,n;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(getWrapProductId(getDrawer())){e.next=2;break}return e.abrupt("return");case 2:return r=bundleSections(),e.next=5,syncWrapLine(t,r);case 5:(n=e.sent)!==t&&dispatchCartChange(n,"gift-wrap:reconcile");case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function handleGiftWrapLineItemChange(e){return _handleGiftWrapLineItemChange.apply(this,arguments)}function _handleGiftWrapLineItemChange(){return (_handleGiftWrapLineItemChange=_asyncToGenerator(_regeneratorRuntime().mark((function e(t){var r,n,a,o,i,c,s,u;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=t.lineKey,n=t.targetQuantity,a=t.lineItem,o=t.host,getWrapProductId(getDrawer())){e.next=3;break}return e.abrupt("return",!1);case 3:return i=bundleSections(),setLoading(!0),e.prev=5,e.next=8,postCartJson("cart/change.js",{id:r,quantity:n,sections:i});case 8:return c=e.sent,e.next=11,syncWrapLine(c,i);case 11:s=e.sent,showLineError(a,""),dispatchCartChange(s,"line-item:change"),e.next=20;break;case 16:e.prev=16,e.t0=e.catch(5),showLineError(a,e.t0.message),null==o||null===(u=o.querySelector("quantity-selector"))||void 0===u||u.restoreDefaultValue();case 20:return e.prev=20,setLoading(!1),e.finish(20);case 23:return e.abrupt("return",!0);case 24:case"end":return e.stop()}}),e,null,[[5,16,20,23]])})))).apply(this,arguments)}function onCheckboxChange(e,t){return _onCheckboxChange.apply(this,arguments)}function _onCheckboxChange(){return (_onCheckboxChange=_asyncToGenerator(_regeneratorRuntime().mark((function e(t,r){var n;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.querySelector("[data-gift-wrap-toggle]"),e.prev=1,e.next=4,toggleWrap(t,r);case 4:e.next=9;break;case 6:e.prev=6,e.t0=e.catch(1),n&&(n.checked=!r);case 9:case"end":return e.stop()}}),e,null,[[1,6]])})))).apply(this,arguments)}function onDocumentChange(e){var t=e.target.closest("".concat(CART_DRAWER_SELECTOR," [data-gift-wrap-toggle]"));if(t){var r=t.closest(CONTROL_SELECTOR);r&&onCheckboxChange(r,t.checked);}}function onCartChange(e){var t,r=null!==(t=e.detail)&&void 0!==t?t:{},n=r.baseEvent,a=r.cart;a&&!SELF_DISPATCHED_EVENTS.includes(n)&&reconcileWrapLine(a).catch((function(){}));}function reconcileOnLoad(){return _reconcileOnLoad.apply(this,arguments)}function _reconcileOnLoad(){return (_reconcileOnLoad=_asyncToGenerator(_regeneratorRuntime().mark((function e(){var t;return _regeneratorRuntime().wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((t=getDrawer())&&"true"!==t.dataset.giftWrapEnabled){e.next=3;break}return e.abrupt("return");case 3:return e.t0=reconcileWrapLine,e.next=6,fetchCart();case 6:return e.t1=e.sent,e.next=9,(0, e.t0)(e.t1);case 9:case"end":return e.stop()}}),e)})))).apply(this,arguments)}window.giftWrapHandleLineItemChange=handleGiftWrapLineItemChange,document.addEventListener("change",onDocumentChange),document.documentElement.addEventListener("cart:change",onCartChange),"loading"===document.readyState?document.addEventListener("DOMContentLoaded",(function(){reconcileOnLoad().catch((function(){}));})):reconcileOnLoad().catch((function(){}));})();